/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateDevourLootboxNftRewardsBatchBody
 */
export interface CreateDevourLootboxNftRewardsBatchBody {
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateDevourLootboxNftRewardsBatchBody
     */
    ids: Array<string>;
}

/**
 * Check if a given object implements the CreateDevourLootboxNftRewardsBatchBody interface.
 */
export function instanceOfCreateDevourLootboxNftRewardsBatchBody(value: object): value is CreateDevourLootboxNftRewardsBatchBody {
    if (!('ids' in value) || value['ids'] === undefined) return false;
    return true;
}

export function CreateDevourLootboxNftRewardsBatchBodyFromJSON(json: any): CreateDevourLootboxNftRewardsBatchBody {
    return CreateDevourLootboxNftRewardsBatchBodyFromJSONTyped(json, false);
}

export function CreateDevourLootboxNftRewardsBatchBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateDevourLootboxNftRewardsBatchBody {
    if (json == null) {
        return json;
    }
    return {
        
        'ids': json['ids'],
    };
}

export function CreateDevourLootboxNftRewardsBatchBodyToJSON(json: any): CreateDevourLootboxNftRewardsBatchBody {
    return CreateDevourLootboxNftRewardsBatchBodyToJSONTyped(json, false);
}

export function CreateDevourLootboxNftRewardsBatchBodyToJSONTyped(value?: CreateDevourLootboxNftRewardsBatchBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ids': value['ids'],
    };
}

